<template>
  <div id="category-page" class="bg-gray-20 flex flex-col gap-2 md:gap-6">
    <product-list>
      <template #title>
        <h1 v-if="isShowTitle" class="text-xl py-3">{{ category?.name }}</h1>
      </template>
      <template #desc>
        <h2 class="py-4 px-5 md:px-0 text-base">{{ category?.intro }}</h2>
      </template>
    </product-list>
    <faq-list v-if="category?.faq_list" class="pb-6 md:pb-10" :category="category" />
  </div>
</template>

<script setup lang="ts">
import ProductList from '@/components/product/product-list.vue'
import FaqList from '@/components/search/faq-list.vue'

import { getCategory } from '@/service/category'

import { useCategoryStore } from '@/store/category'
import { useAppStore } from '@/store/app'
import { GtmEvent } from '@/types/gtm'
import { ASYNC_DATA_KEYS, getAsyncDataKey } from '@/constants/async-data-keys'

definePageMeta({
  middleware: ['check-region'],
})

const route = useRoute()
const app = useAppStore()
const categoryStore = useCategoryStore()

const regionId = computed(() => route.params.rid as string)
const categoryId = computed(() => route.params.cid as string)
const category = computed(() => categoryStore.categoryMap[Number(categoryId.value)])

await useAsyncData(
  getAsyncDataKey(ASYNC_DATA_KEYS.CATEGORY_INFO, [regionId.value, categoryId.value]),
  async () => {
    const { data } = await getCategory(categoryId.value, regionId.value)
    categoryStore.setToCategoryMap(data)
    return data
  },
  { watch: [regionId, categoryId] }
)

useNicedaySeoSetting('category', category)

const isShowTitle = computed(() => app.isDesktopScreen)

onMounted(() => {
  useNuxtApp().$trackEvent(GtmEvent.CATEGORY_VIEWED)
})
</script>

<style lang="scss" scoped>
#category-page {
  min-height: var(--content-min-height);
}
</style>
